exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".list-container {\n    max-height: 300px;\n    overflow-y: auto;\n}\n\n.list-group-item {\n    cursor: pointer;\n}\n\n.dimmed {\n    opacity: 0.5;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/happy/happy-list/happy-list.component.css
// module id = 832
// module chunks = 0